import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=2a467de5&scoped=true&"
import script from "./TableHeader.vue?vue&type=script&lang=ts&"
export * from "./TableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TableHeader.vue?vue&type=style&index=0&id=2a467de5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a467de5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VSpacer,VToolbar})
